import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e0f1713"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "baording-line-modal-container" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "car-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "차량정보", -1 /* HOISTED */))
const _hoisted_5 = { class: "car-no" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1 /* HOISTED */))
const _hoisted_7 = {
  ref: "scrollWrapper",
  class: "content"
}
const _hoisted_8 = { class: "empty-space" }
const _hoisted_9 = {
  key: 0,
  class: "footer-button"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 승차/하차 정류장은 각각 1개만 즐겨찾기할 수 있습니다. 즐겨찾기를 변경하면 기존 정류장의 설정 정보가 삭제됩니다. 새로운 정류장으로 즐겨찾기를 변경하시겠습니까? ", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 이 정류장은 승차와 하차 모두 가능한 정류장입니다. 어떤 용도로 즐겨찾기를 등록하시겠습니까? ", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 이 정류장은 승차와 하차 모두 가능한 정류장입니다. 승차/하차 즐겨찾기는 각각 1개만 등록할 수 있으며, 새로 등록하면 기존 설정은 삭제됩니다. 어떤 용도로 즐겨찾기를 설정하시겠습니까? ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["NavigationBar"], {
        title: $setup.title,
        shouldHideBackButton: true,
        shouldHideCloseButton: false,
        onOnClickClose: $setup.closeModal
      }, null, 8 /* PROPS */, ["title"]),
      _createVNode($setup["SegmentedControl"], {
        segments: $setup.segmentOptions,
        initialIndex: 0,
        onOnChangedSegmentIndex: $setup.updateSegmentIndex
      }, null, 8 /* PROPS */, ["segments"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString($props.onBoardLine.carNo), 1 /* TEXT */)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createVNode($setup["BusStopList"], {
          class: "bus-stop-list",
          busLocations: $props.busLocations,
          lineId: $props.onBoardLine.lineRouteUid,
          turnId: $props.onBoardFavoriteLine?.turnId ?? '',
          busStops: $setup.busStops,
          showInMainCard: false,
          shouldShowGetOffBell: true,
          isOnBoarding: true,
          requestGetOffBusStopId: $props.onBoardFavoriteLine?.requestGetOffBusStopId,
          favoriteGetOnBusStop: $setup.currentFavoriteLine?.getOnBusStop,
          favoriteGetOffBusStop: $setup.currentFavoriteLine?.getOffBusStop,
          detourEndDtm: $setup.currentFavoriteLine?.detourEndDtm,
          shouldShowBusStopLocation: true,
          onOnClickBusStopLocation: $setup.emitOnBusStopLocation,
          onOnClickGetOffBell: $setup.requestGetOffBus,
          onOnClickFavoriteStatusButton: $setup.handleClickFavoriteButton,
          role: "tabpanel",
          id: `segment-panel-${$setup.getSegmentIndex($setup.GET_OFF_BELL_TAB_TITLE)}`,
          "aria-labelledby": `segment-tab-${$setup.getSegmentIndex(
            $setup.GET_OFF_BELL_TAB_TITLE
          )}`,
          "aria-hidden": !$setup.sholudShowBusStopList
        }, null, 8 /* PROPS */, ["busLocations", "lineId", "turnId", "busStops", "requestGetOffBusStopId", "favoriteGetOnBusStop", "favoriteGetOffBusStop", "detourEndDtm", "id", "aria-labelledby", "aria-hidden"]), [
          [_vShow, $setup.sholudShowBusStopList]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, null, 512 /* NEED_PATCH */), [
          [_vShow, $setup.sholudShowBusStopList]
        ]),
        _withDirectives(_createVNode($setup["ReportReasonsSelector"], {
          boardUid: $props.onBoardLine.boardUid,
          role: "tabpanel",
          id: `segment-panel-${$setup.getSegmentIndex($setup.REPORT_TAB_TITLE)}`,
          "aria-labelledby": `segment-tab-${$setup.getSegmentIndex($setup.REPORT_TAB_TITLE)}`,
          "aria-hidden": !$setup.shouldShowReportReasonsSelector
        }, null, 8 /* PROPS */, ["boardUid", "id", "aria-labelledby", "aria-hidden"]), [
          [_vShow, $setup.shouldShowReportReasonsSelector]
        ])
      ], 512 /* NEED_PATCH */),
      ($setup.sholudShowBusStopList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("button", {
              ref: "refreshButton",
              class: "refresh-button",
              type: "button",
              onClick: $setup.onClickRefreshButton
            }, [
              _createVNode($setup["InlineSvg"], {
                class: "refresh-icon",
                src: require('@/assets/icons/refresh.svg'),
                alt: ""
              }, null, 8 /* PROPS */, ["src"]),
              _createTextVNode(" 새로고침 ")
            ], 512 /* NEED_PATCH */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.scrollWrapper)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          class: "scroll-top-wrapper",
          container: $setup.scrollWrapper,
          style: _normalizeStyle({ bottom: $setup.sholudShowBusStopList ? '80px' : '16px' })
        }, null, 8 /* PROPS */, ["container", "style"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" '즐겨찾기 승하차 정류장 변경'전 주의사항 알림 모달 "),
    ($setup.shouldShowFavoriteBusStopChangeAlert)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 1,
          title: "정류장 즐겨찾기 변경 안내",
          okButtonTitle: "변경하기",
          cancelButtonTitle: "취소",
          onOnClickOkButton: $setup.handleClickFavoriteBusStopChangeAlertOk,
          onOnClickCancelButton: $setup.handleClickFavoriteBusStopChangeAlertCancel
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 승/하차 정류장 선택 모달 (추가) "),
    ($setup.shouldShowSelectFavoriteBusStopTypeAddModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 2,
          title: "즐겨찾기 유형 선택",
          modalClass: "favorite-bus-stop-type-add-modal",
          okButtonTitle: "하차 즐겨찾기",
          cancelButtonTitle: "승차 즐겨찾기",
          onOnClickOkButton: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleSelectFavoriteBusStopType(false))),
          onOnClickCancelButton: _cache[1] || (_cache[1] = ($event: any) => {
        $setup.handleSelectFavoriteBusStopType(true);
        $setup.toggleShowSelectFavoriteBusStopTypeAddModal(false);
      })
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 승/하차 정류장 선택 모달 (변경) "),
    ($setup.shouldShowSelectFavoriteBusStopTypeChangeModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 3,
          title: "정류장 즐겨찾기 설정",
          modalClass: "favorite-bus-stop-type-change-modal",
          okButtonTitle: "하차 즐겨찾기",
          cancelButtonTitle: "승차 즐겨찾기",
          onOnClickOkButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.handleSelectFavoriteBusStopType(false))),
          onOnClickCancelButton: _cache[3] || (_cache[3] = ($event: any) => {
        $setup.handleSelectFavoriteBusStopType(true);
        $setup.toggleShowSelectFavoriteBusStopTypeChangeModal(false);
      })
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}